<template>
  <div>
    <custom-dialog width="850px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <div class="add-user-role-dialog">
          <div class="title">
            <h1>{{ $t('base_user_role_bind_dialog.qsyygyxgw') }}</h1>
            <h2>{{ $t('base_user_role_bind_dialog.ygjyybsygwdtdgnqx') }}</h2>
          </div>
          <div class="role-list">
            <ul>
              <li class="ub ub-sp" :class="{ cur: item.selected }" v-for="item in roleList" :key="item.roleId">
                <el-checkbox v-model="item.selected">{{ item.roleName }}</el-checkbox>
                <i class="icon icon-tiaoshi" @click="openRolePer(item)" v-if="item.roleType != 5"></i>
              </li>
            </ul>
          </div>
          <div class="title">
            <h1>{{ $t('base_user_role_bind_dialog.ygxyjssmlxdxx') }}</h1>
            <h2>{{ $t('base_user_role_bind_dialog.qxzygxyjsdxxlx') }}</h2>
          </div>
          <div class="sms-list">
            <ul>
              <li v-for="item in msgRoleList" :key="item.roleId">
                <el-checkbox v-model="item.selected">{{ item.roleName }}</el-checkbox>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" :disabled="!isSubmit" @click="saveUserRole()">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
    <!-- 角色功能权限 -->
    <custom-dialog :title="$t('base_user_role_bind_dialog.gong_neng_quan_xian')" :visible="dialogVisible" @close="dialogVisible = false" width="65%">
      <div style="height: 580px; display: flex; flex-direction: column;">
        <role-permission type="dialog" :orgId="model.data.orgId" :roleId="roleId" @success="dialogVisible = false"></role-permission>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import rolePermission from '@/pages/base/components/rolePermission.vue';

export default {
  mixins: [dialogMixins],
  components: { rolePermission },
  data() {
    return {
      roleList: [],
      msgRoleType: '',
      msgServiceType: '',
      msgServiceList: [],
      msgRoleList: [],
      dialogVisible: false,
      roleId: ''
    };
  },
  computed: {
    isSubmit: vm => vm.roleList.filter(t => t.selected).length || vm.msgRoleList.filter(t => t.selected).length
  },
  mounted() {
    this.getDictionary('bas_role_type', (data) => {
      const msgRoleType = data.bas_role_type.find(t => t.code === 'notice_role') || {};
      const msgServiceType = data.bas_role_type.find(t => t.code === 'service_role') || {};
      this.msgRoleType = msgRoleType.value || '';
      this.msgServiceType = msgServiceType.value || '';
      this.getRoleList();
    });
  },
  methods: {
    // 获取岗位列表
    getRoleList: function () {
      this.$getJSON(apis.UserRoleAll, { isShowNotice: 1, isShowService: 1, orgId: this.model.data.orgId, userId: this.model.data.userId }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.selected = false;
        });
        // 服务类型
        this.msgServiceList = list.filter(t => `${t.roleType}` === `${this.msgServiceType}` && t.state === 1);
        this.msgRoleList = list.filter(t => `${t.roleType}` === `${this.msgRoleType}` && t.state === 1);
        // 自定义
        const roleList = list.filter(t => `${t.roleType}` !== `${this.msgRoleType}` && t.state === 1 && `${t.roleType}` !== `${this.msgServiceType}` && t.state === 1);
        this.roleList = [...this.msgServiceList, ...roleList];
        this.getUserRoleList();
      });
    },
    // 获取用户岗位列表
    getUserRoleList: function () {
      if (!this.model.data.userId) {
        return;
      }
      this.$getJSON(apis.UserRole, { bizId: this.model.data.userId }).then((res) => {
        const userRoleIds = res.data.map(t => t.roleId);
        this.roleList.forEach((item) => {
          item.selected = userRoleIds.includes(item.roleId);
        });
        this.msgRoleList.forEach((item) => {
          item.selected = userRoleIds.includes(item.roleId);
        });
      });
    },
    // 保存用户岗位
    saveUserRole: function () {
      const roleIds = [...this.roleList, ...this.msgRoleList].filter(t => t.selected).map(f => f.roleId);
      this.$postJSON(
        apis.UserRoleAdd,
        {
          bizId: this.model.data.userId,
          bizName: this.model.data.userName,
          bizType: 3,
          roleIds: roleIds
        },
        true
      ).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success')
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    openRolePer: function (item) {
      this.roleId = item.roleId;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="scss">
.add-user-role-dialog {
  .title {
    position: relative;
    h1 {
      line-height: 20px;
      font-weight: bold;
      color: #404040;
      font-size: 14px;
    }
    h2 {
      color: #999999;
      font-size: 12px;
      margin-top: 10px;
      margin-bottom: 20px;
    }
  }
  h1 {
    color: #2c405e;
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
  }
  p {
    color: #bbbbbb;
    font-size: 12px;
    margin-top: 8px;
    margin-bottom: 16px;
    line-height: 17px;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 14px;
  }
  ul li {
    position: relative;
    width: 220px;
    height: 40px;
    line-height: 40px;
    background-color: #f8f9fb;
    border-radius: 2px;
    margin-right: 10px;
    margin-bottom: 10px;
    padding-right: 12px;
    color: #4e5e7b;
    font-size: 12px;
    .el-checkbox {
      flex: 1;
      padding-left: 12px;
    }
    .el-checkbox__label {
      font-size: 12px;
      color: #495057;
      font-weight: normal;
    }
    .icon {
      color: #adb5bd;
      cursor: pointer;
    }
    &.add-role {
      cursor: pointer;
      background: none;
      color: #2aafff;
      text-align: center;
      border: 1px rgba(217, 217, 217, 1) dashed;
    }
  }
}
</style>
